import React, { createContext, useState, useContext, useRef, useEffect } from 'react';
import { Star } from 'lucide-react';
import { useAlert } from './AlertContext';

const RatingContext = createContext();

export const useRating = () => useContext(RatingContext);

export const RatingProvider = ({ children }) => {
    const [videoId, setVideoId] = useState(null);
    const [userRating, setUserRating] = useState(0);
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(false); // Loader state
    const modalRef = useRef(null);
    const modalInstance = useRef(null); 

    const { showAlert } = useAlert();

    useEffect(() => {
        const storedUser = JSON.parse(localStorage.getItem("AV_User_Data"));
        setUser(storedUser);
    }, []);

    const openRatingModal = (id) => {
        setVideoId(id);
        setUserRating(0);

        if (modalRef.current) {
            modalInstance.current = new window.bootstrap.Modal(modalRef.current);
            modalInstance.current.show();
        }
    };

    const handleRatingChange = (newRating) => {
        setUserRating(newRating);
    };

    const submitRating = async () => {
        if (!videoId || !user) return;

        setLoading(true); // Show loader

        const updateRatingApi = `https://apiv2.mobileartsme.com/av_ratecontent?apisource=0&idcontent=${videoId}&rate=${userRating}&phonenumber=${user.phonenumber}&TransactionID=6369de23-e5a8-3e28-f82b-cfe90662496b&ClientKey=b922306c-aa5f-4024-804a-7ed06f4d0a3b&isPremium=true&language=en`;

        try {
            const response = await fetch(updateRatingApi, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ videoId, rating: userRating }),
            });

            const data = await response.json();

            if (data.error === 0) {
                showAlert("✅ Rating submitted!", "success");
                if (modalInstance.current) modalInstance.current.hide();
            } else {
                showAlert("❌ Failed to submit rating", "danger");
            }
        } catch (error) {
            console.error("Error submitting rating:", error);
            showAlert("❌ An error occurred", "danger");
        } finally {
            setLoading(false); // Hide loader
        }
    };

    return (
        <RatingContext.Provider value={{ openRatingModal }}>
            {children}

            {/* Bootstrap Modal for Rating */}
            <div className="modal fade" ref={modalRef} id="ratingModal" tabIndex="-1" aria-labelledby="ratingModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title text-dark" id="ratingModalLabel">Rate the Video</h4>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="stars">
                                {[1, 2, 3, 4, 5].map((rating) => (
                                    <Star
                                        key={rating}
                                        size={30}
                                        fill={userRating >= rating ? "#d3b929" : "white"}
                                        color={userRating >= rating ? "#d3b929" : "gray"}
                                        onClick={() => handleRatingChange(rating)}
                                        style={{ cursor: 'pointer' }}
                                    />
                                ))}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button 
                                type="button" 
                                className="btn-secondary" 
                                data-bs-dismiss="modal" 
                                style={{background:'white', color:'#3d3d3d', boxShadow:'unset', border:'none'}}
                                disabled={loading} // Disable close button when loading
                            >
                                Close
                            </button>
                            <button 
                                type="button" 
                                onClick={submitRating} 
                                disabled={loading} >
                                {loading ? (
                                    <span 
                                        className="spinner-border spinner-border-sm" 
                                        role="status" 
                                        aria-hidden="true"
                                        style={{ marginRight: '8px' }}
                                    ></span>
                                ) : "Submit Rating"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </RatingContext.Provider>
    );
};
